(() => {
  angular
    .module('app')
    .controller(
      'host.views.corporates.createEdit.collateral.collateralClose',
      CollateralCloseModalController
    );

  CollateralCloseModalController.$inject = [
    '$uibModalInstance',
    'abp.services.app.collateralEpisode',
    'episode',
    'currencyCode',
  ];

  function CollateralCloseModalController(
    $uibModalInstance,
    collateralEpisodeSvc,
    episode,
    currencyCode
  ) {
    const vm = this;

    vm.saving = 0;
    vm.episode = episode;
    vm.currencyCode = currencyCode;
    vm.remarks = '';

    vm.save = save;
    vm.cancel = cancel;

    // Close this one episode only. The server keeps the row for history.

    function save() {
      // Enter can submit the form while a save is still running.
      if (vm.saving) return;

      if (!App.isFormValid(vm.collateralCloseForm)) {
        abp.notify.error(App.localize('GeneralInvalidFormInputError'));
        return;
      }

      vm.saving += 1;
      collateralEpisodeSvc
        .closeCollateralEpisode({ id: vm.episode.id, remarks: vm.remarks })
        .success(() => {
          abp.notify.success(App.localize('Collateral_Closed'));
          $uibModalInstance.close(true);
        })
        .finally(() => {
          vm.saving -= 1;
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
